import { TagImage } from './TagImage';
export default TagImage;



// WEBPACK FOOTER //
// ./src/components/atomic/atoms/TagImage/index.js